import { Testimonial } from "@/types/testimonial";

const testimonialsData: Testimonial[] = [
  {
    review: `Laptop yang aku sewa dari sini kualitasnya oke banget! Di Jakarta, jarang ada penyedia sewa laptop yang kasih spek tinggi, harga masuk akal, dan performa stabil. Cocok buat nugas atau kerja harian. Gak nyesel deh!`,
    authorName: "Ahmad Fadli",
    authorImg: "/images/users/user-01.webp",
    authorRole: "Mahasiswa",
  },
  {
    review: `Sewa printer buat proyek desain di Bogor, hasil cetaknya tajam dan rapi. Tipe yang aku dapet bener" sesuai kebutuhan. Nggak ngadat, gak makan waktu. Harga kompetitif, pelayanan pun ramah dan fast respon.`,
    authorName: "Lilis Suryani",
    authorImg: "/images/users/user-02.webp",
    authorRole: "Desainer Grafis",
  },
  {
    review: `Aku sewa kamera buat dokumentasi reuni keluarga. Gambar yang dihasilkan jernih asli, low light pun tetap tajam. Lokasi pengiriman di Tangerang, tetap on-time. Adminnya enak diajak diskusi soal kebutuhan spek. Recommended!`,
    authorName: "Rahmat Hidayat",
    authorImg: "/images/users/user-03.webp",
    authorRole: "Guru",
  },
  {
    review: `Sound systemnya keren yak! Suara jernih, bass-nya berasa, cocok bangat buat acara outdoor di Bekasi. Temen² sampai tanya sewa dimana. Adminnya tanggap dan setting alatnya cepat. Pokoknya kalau cari sewa sound system, ini tempatnya!`,
    authorName: "Yayan Suryana",
    authorImg: "/images/users/user-04.webp",
    authorRole: "Event Organizer",
  },
  {
    review: `Drone yang aku sewa dikirim lengkap sama pilotnya. Unitnya DJI, kualitas gambar video 4K stabil beud. Abangnya paham teknis shooting. Harga fleksibel tergantung durasi. Di Jakarta, susah nemu yang bisa sekeren ini!`,
    authorName: "Eka Prasetyo",
    authorImg: "/images/users/user-05.webp",
    authorRole: "Content Creator",
  },
  {
    review: `Nobar bola jadi gacorrr! Proyektor yang aku sewa bikin lapangan terasa kayak stadion. Layarnya gede gila sih, terang meski outdoor. Unitnya branded, dan semua disettingin sampai beres. Harga? Murah dibanding senengnya kita.`,
    authorName: "Dedi Firmansyah",
    authorImg: "/images/users/user-06.webp",
    authorRole: "Wiraswasta",
  },
];

export default testimonialsData;